import React from 'react';

import { AuthProvider } from '/src/machines/auth';
import { AppProvider } from '/src/contexts/app';
import { CrazyAIProvider } from '/src/contexts/CrazyAI';
import { isE2E } from '/src/utils';
import { Router } from './Router';

// eslint-disable-next-line no-restricted-syntax
export default function App({ client }) {
  const appTree = (
    <CrazyAIProvider>
      <AppProvider client={client}>
        <AuthProvider>
          <Router />
        </AuthProvider>
      </AppProvider>
    </CrazyAIProvider>
  );

  if (isE2E()) {
    return appTree;
  }

  return <React.StrictMode>{appTree}</React.StrictMode>;
}
